import React, {
  useEffect, useState, useContext,
} from 'react';
import PropTypes from 'prop-types';
import { MemberContext } from '../context';

const GroupedRedirectionAnchor = (props) => {
  const {
    fieldId,
    anchorOptions = [],
    showFromMemberInfo,
    commonURL,
    cssProperties,
  } = props;

  const [anchorList, setAnchorList] = useState([]);

  const memberContextVal = useContext(MemberContext);

  useEffect(() => {
    if (showFromMemberInfo) {
      const options = memberContextVal.map((context) => ({
        label: context.product.digitalInfo.productDesc,
        redirectionURL: commonURL,
      }));
      setAnchorList(options);
    } else {
      setAnchorList(anchorOptions);
    }
  }, []);

  return (

    <div id={fieldId}>
      {anchorList.map((option) => (
        <>
          <p className={cssProperties.style}>
            <a className={cssProperties.anchorStyle} title={`${option.label} Link`} href={option.redirectionURL} target="_blank" rel="noreferrer">
              {option.label}
            </a>
          </p>
          <hr className="col-md-8" />
        </>

      ))}
    </div>

  );
};

GroupedRedirectionAnchor.propTypes = {
  fieldId: PropTypes.string,
  anchorOptions: PropTypes.objectOf(PropTypes.shape),
  commonURL: PropTypes.string,
  cssProperties: PropTypes.objectOf(PropTypes.shape),
  showFromMemberInfo: PropTypes.bool,
};

export default GroupedRedirectionAnchor;
